import { IConfigsType } from '../../types'

const fwWingstopPrepToolFeedback: IConfigsType = {
  'fw_wingstop-prep-item-calculator-store-users-079bdb89': {
    '/:brand/prep_tool_feedback': {
      pageTitle: {
        type: 'title',
        title: 'Prep Tool Feedback',
      },
      feedbackLink: {
        type: 'link',
        label: 'Google Form',
        href: 'https://forms.gle/TENp76DGPFd9DBya6',
      },
    },
  },
}

export default fwWingstopPrepToolFeedback
